import keymirror from 'keymirror';

export default keymirror({
  cover: null,
  contain: null,
  repeat: null,
});
